import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useAuth } from "../../Componants/AdminPannel/useAuth";

const DashboardLayout = () => {
  useAuth();

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar - fixed */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 ml-64"> 
        {/* Navbar - fixed */}
        <Navbar />

        {/* Scrollable Main Section */}
        <main className="flex-1 overflow-y-auto p-6 mt-14">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
